import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const Loading = () => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center">
    <Loader2 className="h-8 w-8 neon-text animate-spin" />
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false, shared = false }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  const isAdmin = user.role === "admin" || user.role === "owner";
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;
  if (!adminOnly && !shared && isAdmin) return <Navigate to="/admin" replace />;
  return children;
};
